import './login.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
var Form = Controls.Form,
  Text = Controls.Text;
var isEmail = validators.isEmail;
var defaultValues = {
  email: '',
  password: ''
};
function ForgotPasswordV2(_ref) {
  var requestPasswordReset = _ref.requestPasswordReset,
    _ref$passwordResetEma = _ref.passwordResetEmail,
    passwordResetEmail = _ref$passwordResetEma === void 0 ? false : _ref$passwordResetEma,
    processing = _ref.processing;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "new-login w-50 mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center w-75 mx-auto mb-4"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "password-reset"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 have-account"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Back to sign-in"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: requestPasswordReset,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 text-start common-size"
  }, /*#__PURE__*/React.createElement(T, {
    source: "password-reset-sub-heading"
  })), !passwordResetEmail ? /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(Text, {
    name: "email",
    placeholder: "work-personal-email",
    styles: {
      wrapper: 'row m-0',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    validators: {
      isEmail: isEmail
    },
    ariaLabel: "work-personal-email"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "reset-success px-2 py-4 mx-0 mt-0 mb-4 row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1 p-0 d-flex justify-content-center align-items-center check-color"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-check"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-11 p-0 text-start"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.reset-password-success-message"
  }))), passwordResetEmail ? /*#__PURE__*/React.createElement("div", {
    className: "agree-button w-100 mt-4"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Go back to Sign-in"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "agree-button w-100"
  }, processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "request-password-reset-link"
  }))))))));
}
export default ForgotPasswordV2;